import { Company } from "../companies/company";
import { Entity } from "../companies/entity";
import { AlertSeverity, AlertStatus, AlertType, ResolvedStatus } from "./alerts-enums";
import { EntityType } from "../common/entity-type.enum";
import { Individual } from "../individuals/individual";
import { Trust } from "../trusts/trust";
import { Guid } from "../../shared/utils/guid.helper";
import { AlertDetailBase } from "./alert-detail-base";
import { AlertRecord } from "./alert-record";

export class Alert {
  id: string;
  entityId?: string;
  entity?: Company | Trust | Entity | null;
  entityType: EntityType | null;
  individualId?: string;
  individual?: Individual;
  hash: string;
  status: AlertStatus | undefined;
  resolvedStatus: ResolvedStatus | undefined;
  type: AlertType | undefined;
  severity: AlertSeverity | undefined;
  postponedTill?: Date;
  createdOn: Date;
  alertDetail: AlertDetailBase;
  isRead: boolean;
  needAttention: boolean;

  constructor(data: Partial<Alert> = {}) {
    this.id = data.id ?? Guid.EmptyGuid;
    this.entityId = data.entityId;
    this.entity = data.entity ?? null;
    this.entityType = data.entityType ?? null;
    this.individualId = data.individualId;
    this.individual = data.individual;
    this.hash = data.hash ?? "";
    this.status = data.status;
    this.resolvedStatus = data.resolvedStatus;
    this.type = data.type;
    this.severity = data.severity;
    this.postponedTill = data.postponedTill;
    this.createdOn = data.createdOn ?? new Date();
    this.isRead = data.isRead ?? false;
    this.needAttention = data.needAttention ?? false;
    if (!data.alertDetail) {
      throw new Error("Alert detail is required for Alert");
    }
    this.alertDetail = data.alertDetail;
  }

  public static toAlertRecord(alert: Alert | Partial<Alert>): AlertRecord {
    return new AlertRecord({
      id: alert.id,
      entityId: alert.entityId,
      individualId: alert.individualId,
      entityName: alert.entity?.name,
      status: alert.status,
      resolvedStatus: alert.resolvedStatus,
      type: alert.type,
      severity: alert.severity,
      createdOn: alert.createdOn,
      isRead: alert.isRead,
      modelDetailTitle: alert.alertDetail?.title,
      postponedTill: alert.postponedTill,
      needAttention: alert.needAttention
    });
  }
}

